import axios from "axios";
import React, { useEffect, useState } from "react";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Link } from "react-router-dom";

import Pending from "../../../../../assets/Icon/pending.png";
import avatarImage from "../../../../../assets/images/profileAvatar/Avater.png";
import "./AddSuperStar.css";
import noImage from "../../../../../../src/assets/images/settings/no-image.png";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const AddSuperStar = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [filem, setFilem] = useState([]);

  const [loading, setLoading] = useState(true);

  const [file, setFile] = useState("");

  const [stars, setStars] = useState([]);
  const [star, setStar] = useState({});
  const [starDetails, setStarDetails] = useState("");

  const getStar = () => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStars(res.data.star);
        setFile(
          res.data.star?.image != null
            ? imageCdnUrl + res.data.star.image
            : avatarImage
        );
        starDetailsHandler(res.data.star[0]?.id);
      }
    });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    getStar();
  }, []);

  const starDetailsHandler = (id) => {
    axios.get(`/api/admin/user_info/${id}`).then((res) => {
      if (res.data.status === 200) {
        setStar(res.data.users);
        if (res.data?.star_details?.qr_code != null) {
          setStarDetails(res.data?.star_details);
        }
      }
    });
    setLoading(false);
  };

  if (loading) {
    return <LoaderPost />;
  } else {
  }

  return (
    <>
      <AllDataHeader title="Super Stars" image={Pending} count={"Zero"} />
      <div className="row">
        {stars.map((star, index) => (
          <>
            <div className="col-sm-6 col-md-3 mb-2">
              <div className="card card-bg Star-Super">
                <img
                  src={
                    star?.cover_photo != null
                      ? imageCdnUrl + star?.cover_photo
                      : noImage
                  }
                  className="Star-banner img-fluid rounded-3 p-2 "
                  alt={noImage}
                />
                <div className="d-flex align-items-center p-2">
                  <div className="col-md-2">
                    <div className="card bg-black">
                      <img
                        src={
                          star.image != null
                            ? imageCdnUrl + star.image
                            : noImage
                        }
                        className="Star-one-img  "
                        alt="profile-pic"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="text-light px-2 nam_star">
                      <span className="fw-bold text-warning star_c-s">
                        {star.first_name} {star.last_name}
                      </span>
                      <br />
                      <small>{star.sub_category?.name}</small>{" "}
                      &nbsp;&nbsp;&nbsp;
                      <Link to={`superstar/edit/${star.id}`}>
                        <i class="fa-solid fa-pen-to-square  p-1  btnE "></i>
                      </Link>
                      {starDetails && starDetails.id ? (
                        <Link
                          to={`/superstar-admin/agreement-paper/${star.id}`}
                        >
                          <i class="fa-solid fa-qrcode p-1 btnEye mx-2"></i>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default AddSuperStar;
